import { GAME_CONSTANTS } from '../constants';
import { resolvePublicAssetPath, resolvePublicAssetPaths } from './assets';

interface GlobalConfig {
  trainingDummy: {
    appearance: {
      idle: string;
      active: string;
    };
  };
  ui: {
    defaultGcd: number;
    minGcd: number;
    maxGcd: number;
  };
}

let globalConfig: GlobalConfig | null = null;

export const loadGlobalConfig = async (): Promise<GlobalConfig> => {
  if (globalConfig) {
    return globalConfig;
  }

  try {
    const response = await fetch(resolvePublicAssetPath('/data/global/config.json'));
    if (!response.ok) {
      throw new Error(`Failed to load global config: ${response.statusText}`);
    }
    const config = await response.json();
    const resolvedConfig = resolvePublicAssetPaths(config);
    globalConfig = resolvedConfig;
    return resolvedConfig;
  } catch (error) {
    console.error('Error loading global config:', error);
    // 返回默认配置
    globalConfig = {
      trainingDummy: {
        appearance: {
          idle: resolvePublicAssetPath('/data/global/image/training_dummy_idle.gif'),
          active: resolvePublicAssetPath('/data/global/image/training_dummy_hit.gif')
        }
      },
      ui: {
        defaultGcd: GAME_CONSTANTS.DEFAULT_GCD,
        minGcd: GAME_CONSTANTS.MIN_GCD,
        maxGcd: GAME_CONSTANTS.MAX_GCD
      }
    };
    return globalConfig;
  }
};

export const getGlobalConfig = (): GlobalConfig | null => {
  return globalConfig;
};
